<div class="error-dialog-wrapper">
    <mat-icon>error</mat-icon>
    <div mat-dialog-content >
        <h4>{{data.title || 'Någonting gick fel'}}</h4>
        <p *ngFor="let msg of data.message">{{msg}}</p>
    </div>
    <div mat-dialog-actions class="buttons">
        <button mat-button (click)="close()">Stäng</button>
    </div>
</div>